import { AssessmentDisplayStatus } from '@equip.health/ui';

import { SurveyName } from '~/lib/constants/survey/SurveyName';
import {
  getAimsSurveyBadgeColumns,
  getAuditSurveyRiskBadge,
  getCssrsLifetimeSurveyBadgeColumns,
  getCssrsSinceLastContactScoreAndRiskBadge,
  getCssrsSlcScreenRiskBadge,
  getDuditSurveyRiskBadge,
  getGad7SurveyRiskBadge,
  getNiaaaBstadSurveyBadgeColumns,
  getPhq8SurveyBadgeRiskBadge,
} from '~/lib/util/surveyBadge.util';
import util from '~/lib/util/util';

interface SurveyScoreBadgeProps {
  id: string;
  jsonResults?: string;
  patientGender?: string;
  score: number;
  surveyName: SurveyName;
  surveyInstanceStatus?: AssessmentDisplayStatus;
}

const SurveyScoreBadge = ({
  id,
  jsonResults,
  patientGender,
  score,
  surveyName,
  surveyInstanceStatus,
}: SurveyScoreBadgeProps) => {
  switch (surveyName) {
    case SurveyName.C_SSRS_LIFETIME:
      return getCssrsLifetimeSurveyBadgeColumns(
        id,
        util.parseJson(jsonResults),
      );
    case SurveyName.C_SSRS_SINCE_LAST_CONTACT:
      return getCssrsSinceLastContactScoreAndRiskBadge(
        id,
        util.parseJson(jsonResults),
      );
    case SurveyName.C_SSRS_SLC_SCREENER:
      return getCssrsSlcScreenRiskBadge(id, util.parseJson(jsonResults));
    case SurveyName.NIAAA_BSTAD:
      return getNiaaaBstadSurveyBadgeColumns(id, util.parseJson(jsonResults));
    case SurveyName.PHQ8:
    case SurveyName.PHQ9:
      return score == null ? null : getPhq8SurveyBadgeRiskBadge(score, id);
    case SurveyName.GAD7:
      return !score ? null : getGad7SurveyRiskBadge(score, id);
    case SurveyName.AUDIT:
      return !score ? null : getAuditSurveyRiskBadge(score, id);
    case SurveyName.DUDIT:
      return !score ? null : getDuditSurveyRiskBadge(score, id, patientGender);
    case SurveyName.AIMS:
      return getAimsSurveyBadgeColumns(id, jsonResults, surveyInstanceStatus);
    default:
      return null;
  }
};

export default SurveyScoreBadge;
